module.exports = __webpack_public_path__ + "static/media/BC-Snake_Sform.1183af0c.png";